import {IHistoryRecordViewModel} from "../record/history-record-view-model.interface";
import {IHistoryPaginatorViewModel} from "./history-paginator-view-model.interface";

export class VoidGamingHistoryPaginatorModel implements IHistoryPaginatorViewModel {

    get daysIntervals(): number[] 
    {
        return [];
    }

    setNumberOfHistoryDays(numberOfDays: number): void {}
    get isLoading(): boolean {
        return false;
    }
    get hasMoreRecords(): boolean {
        return false;
    }
    get records(): IHistoryRecordViewModel[] {
        return []
    }
    async loadNextPage(): Promise<void> {
    }
}